
export default function ServiceArea() {
  return (
    <section id="area" className="py-16 px-4 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-6">
          対応住宅・エリア
        </h2>
        <p className="text-center text-gray-700 font-normal text-base leading-relaxed mb-12">
          戸建て住宅を中心に、<br />
          マンション・アパートにも対応しています。
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* 江田島市 */}
          <div className="bg-gradient-to-br from-cyan-50 to-white rounded-2xl p-8 shadow-lg border-2 border-cyan-300">
            <div className="text-center">
              <div className="w-20 h-20 flex items-center justify-center bg-cyan-500 rounded-full mx-auto mb-4">
                <i className="ri-map-pin-fill text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">江田島市</h3>
              <p className="text-base text-gray-700 font-normal leading-relaxed mb-2">全域対応</p>
              <div className="inline-block bg-cyan-100 rounded-full px-6 py-2 mt-2">
                <p className="text-sm font-bold text-cyan-700">出張費なし</p>
              </div>
            </div>
          </div>

          {/* 呉市 */}
          <div className="bg-gradient-to-br from-yellow-50 to-white rounded-2xl p-8 shadow-lg border-2 border-yellow-300">
            <div className="text-center">
              <div className="w-20 h-20 flex items-center justify-center bg-yellow-500 rounded-full mx-auto mb-4">
                <i className="ri-map-pin-2-fill text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">呉市</h3>
              <p className="text-base text-gray-700 font-normal leading-relaxed mb-2">対応可能</p>
              <div className="inline-block bg-yellow-100 rounded-full px-6 py-2 mt-2">
                <p className="text-sm font-bold text-yellow-700">税込1,100円</p>
              </div>
            </div>
          </div>
        </div>

        {/* 注意事項 */}
        <div className="mt-10 bg-gray-50 rounded-xl p-6">
          <div className="flex items-start gap-3">
            <i className="ri-information-line text-2xl text-cyan-600 flex-shrink-0 mt-1"></i>
            <p className="text-sm text-gray-700 font-normal text-left leading-relaxed">
              ※ 呉市での作業は、出張費として別途1,100円（税込）をお願いしています
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
